module.exports = __webpack_public_path__ + "img/login.9a198d72.jpg";